function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component } from 'react';
import { themeNames, createThemeClassName, themeNameDefault } from '@shopify/polaris-tokens';
import { ThemeContext, getTheme } from '../../utilities/use-theme.js';
import './AppProvider.scss.js';
import './global.scss.js';
import { classNamePolarisSummerEditions2023, FeaturesContext } from '../../utilities/features/context.js';
import { StickyManager } from '../../utilities/sticky-manager/sticky-manager.js';
import { ScrollLockManager } from '../../utilities/scroll-lock-manager/scroll-lock-manager.js';
import { I18n } from '../../utilities/i18n/I18n.js';
import { I18nContext } from '../../utilities/i18n/context.js';
import { ScrollLockManagerContext } from '../../utilities/scroll-lock-manager/context.js';
import { StickyManagerContext } from '../../utilities/sticky-manager/context.js';
import { LinkContext } from '../../utilities/link/context.js';
import { MediaQueryProvider } from '../MediaQueryProvider/MediaQueryProvider.js';
import { PortalsManager } from '../PortalsManager/PortalsManager.js';
import { FocusManager } from '../FocusManager/FocusManager.js';
import { EphemeralPresenceManager } from '../EphemeralPresenceManager/EphemeralPresenceManager.js';
var MAX_SCROLLBAR_WIDTH = 20;
var SCROLLBAR_TEST_ELEMENT_PARENT_SIZE = 30;
var SCROLLBAR_TEST_ELEMENT_CHILD_SIZE = SCROLLBAR_TEST_ELEMENT_PARENT_SIZE + 10;
function measureScrollbars() {
  var _parentEl$firstElemen, _parentEl$firstElemen2;
  var parentEl = document.createElement('div');
  parentEl.setAttribute('style', "position: absolute; opacity: 0; transform: translate3d(-9999px, -9999px, 0); pointer-events: none; width:".concat(SCROLLBAR_TEST_ELEMENT_PARENT_SIZE, "px; height:").concat(SCROLLBAR_TEST_ELEMENT_PARENT_SIZE, "px;"));
  var child = document.createElement('div');
  child.setAttribute('style', "width:100%; height: ".concat(SCROLLBAR_TEST_ELEMENT_CHILD_SIZE, "; overflow:scroll"));
  parentEl.appendChild(child);
  document.body.appendChild(parentEl);
  var scrollbarWidth = SCROLLBAR_TEST_ELEMENT_PARENT_SIZE - ((_parentEl$firstElemen = (_parentEl$firstElemen2 = parentEl.firstElementChild) === null || _parentEl$firstElemen2 === void 0 ? void 0 : _parentEl$firstElemen2.clientWidth) !== null && _parentEl$firstElemen !== void 0 ? _parentEl$firstElemen : 0);
  var scrollbarWidthWithSafetyHatch = Math.min(scrollbarWidth, MAX_SCROLLBAR_WIDTH);
  document.documentElement.style.setProperty('--pc-app-provider-scrollbar-width', "".concat(scrollbarWidthWithSafetyHatch, "px"));
  document.body.removeChild(parentEl);
}
var AppProvider = /*#__PURE__*/function (_Component) {
  function AppProvider(props) {
    var _this;
    _classCallCheck(this, AppProvider);
    _this = _callSuper(this, AppProvider, [props]);
    _this.setBodyStyles = function () {
      document.body.style.backgroundColor = 'var(--p-color-bg)';
      document.body.style.color = 'var(--p-color-text)';
    };
    _this.setRootAttributes = function () {
      var activeThemeName = _this.getThemeName();
      themeNames.forEach(function (themeName) {
        document.documentElement.classList.toggle(createThemeClassName(themeName), themeName === activeThemeName);
      });
      document.documentElement.classList.add(classNamePolarisSummerEditions2023);
    };
    _this.getThemeName = function () {
      var _this$props$theme;
      return (_this$props$theme = _this.props.theme) !== null && _this$props$theme !== void 0 ? _this$props$theme : themeNameDefault;
    };
    _this.stickyManager = new StickyManager();
    _this.scrollLockManager = new ScrollLockManager();
    var _this$props = _this.props,
      i18n = _this$props.i18n,
      linkComponent = _this$props.linkComponent;

    // eslint-disable-next-line react/state-in-constructor
    _this.state = {
      link: linkComponent,
      intl: new I18n(i18n)
    };
    return _this;
  }
  _inherits(AppProvider, _Component);
  return _createClass(AppProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (document != null) {
        this.stickyManager.setContainer(document);
        this.setBodyStyles();
        this.setRootAttributes();
        var isSafari16 = navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome') && (navigator.userAgent.includes('Version/16.1') || navigator.userAgent.includes('Version/16.2') || navigator.userAgent.includes('Version/16.3'));
        if (isSafari16) {
          document.documentElement.classList.add('Polaris-Safari-16-Font-Optical-Sizing-Patch');
        }
      }
      measureScrollbars();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var prevI18n = _ref.i18n,
        prevLinkComponent = _ref.linkComponent;
      var _this$props2 = this.props,
        i18n = _this$props2.i18n,
        linkComponent = _this$props2.linkComponent;
      this.setRootAttributes();
      if (i18n === prevI18n && linkComponent === prevLinkComponent) {
        return;
      }
      this.setState({
        link: linkComponent,
        intl: new I18n(i18n)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        children = _this$props3.children,
        features = _this$props3.features;
      var themeName = this.getThemeName();
      var _this$state = this.state,
        intl = _this$state.intl,
        link = _this$state.link;
      return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
        value: getTheme(themeName)
      }, /*#__PURE__*/React.createElement(FeaturesContext.Provider, {
        value: features
      }, /*#__PURE__*/React.createElement(I18nContext.Provider, {
        value: intl
      }, /*#__PURE__*/React.createElement(ScrollLockManagerContext.Provider, {
        value: this.scrollLockManager
      }, /*#__PURE__*/React.createElement(StickyManagerContext.Provider, {
        value: this.stickyManager
      }, /*#__PURE__*/React.createElement(LinkContext.Provider, {
        value: link
      }, /*#__PURE__*/React.createElement(MediaQueryProvider, null, /*#__PURE__*/React.createElement(PortalsManager, null, /*#__PURE__*/React.createElement(FocusManager, null, /*#__PURE__*/React.createElement(EphemeralPresenceManager, null, children))))))))));
    }
  }]);
}(Component);
export { AppProvider };